import { createSelector } from '@reduxjs/toolkit';
import { AppState } from 'store';
import { IErrorState } from './error.interface';

export const errorsSelector = ({ error: { errors } }: AppState): IErrorState['errors'] => errors;

export const getErrorsSelector = createSelector(errorsSelector, (errors) => errors);
